








































import {
  ChillPayMainPaymentChannel,
  ChillPayPaymentChannel,
  FinanceType,
  LoadingStatusType,
  TransactionType,
  TypeComponentNoti,
} from "@/enums/enums";
import { ChillPayRequestModel } from "@/model/payment/paymentModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StorePayment = namespace("Payment");
const StoreLoading = namespace("Loading");
const StoreAlert = namespace("Alert");
const StoreMerchant = namespace("Merchant");

const urlImg = process.env.VUE_APP_PeakBlobStorage + "peakengine/Content/Image/";

@Component
export default class ModalConfirmKBankPaymentChillPay extends Vue {
  @Prop({ default: 0 }) transactionId!: number;
  @Prop({ default: TransactionType.None }) transactionType!: TransactionType;
  @Prop({ default: FinanceType.None }) financeType!: FinanceType;
  @Prop({ default: 30 }) timeWaitingPayment!: number;

  private showModal = true;
  private isShowFormSubmit = false;

  private mainPaymentChannel: any = [];
  private pickMainPaymentChannel: ChillPayMainPaymentChannel = ChillPayMainPaymentChannel.QRPromptPay;

  private paymentChannel: any = [];
  private pickPaymentChannel = ChillPayPaymentChannel.None;

  private phoneNumber: any = {
    value: "",
    validateError: false,
  };

  @StoreMerchant.Getter
  private getMerchantQRPaymentModel!: any;
  @StoreMerchant.Getter
  private getMerchantQRPaymentSettingLoadingStatus!: LoadingStatusType;

  @StoreMerchant.Action
  private DoGetQRPaymentSetting!: () => void;
  @StoreLoading.Action
  private IsLoading!: (input: boolean) => void;
  @StoreAlert.Action
  private SetAlertMessage!: (input: any) => void;
  @StorePayment.Action
  private DoGetChillPayPayment!: (input: ChillPayRequestModel) => void;

  created() {}

  get isPaymentDisabled() {
    return false;
  }

  @Watch("showModal")
  showModalChanged() {
    if (!this.showModal) {
      this.HideModal();
    }
  }

  public GetChillPayPayment() {
    var phoneNumberData = this.phoneNumber.value.trim();

    if (phoneNumberData) {
      const input: ChillPayRequestModel = {
        transactionId: this.transactionId,
        transactionTypeId: this.transactionType,
        paymentChannelType: ChillPayPaymentChannel.PayPlus_Kbank,
        phoneNumber: this.phoneNumber.value,
      };
      this.DoGetChillPayPayment(input);
    } else {
      this.phoneNumber.validateError = true;
    }
  }

  public ClearValidateData() {
    this.phoneNumber.validateError = false;
  }

  public SubmitToPaySolutions() {
    this.IsLoading(true);
    this.isShowFormSubmit = true;

    setTimeout(() => {
      const formSubmit: any = this.$refs.formSubmit;
      formSubmit.submit();
    }, 0);
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }
}
